import React from 'react';
import { CONTENT_ARCHIVE } from 'config/types/prop';
import ContentList from 'components/contentList';
import withStyles from 'isomorphic-style-loader/withStyles';
import ShowMoreButton from 'components/showMoreButton';
import useAccessibilityFocusLastAfterLoading from 'hooks/useAccessibilityFocusLastAfterLoading';

import styles from '../contentArchive.css';

const DefaultContentArchive = ({
  items,
  pagination: {
    hasMore,
  },
  loadingMore,
  onLoadMore,
  typeLabel,
}) => {
  const onFocus = useAccessibilityFocusLastAfterLoading({ loading: loadingMore });

  return (
    <div className={styles.wrapper}>
      <header>
        <h1>{typeLabel}</h1>
      </header>
      <main>
        <ContentList
          onFocus={onFocus}
          items={items}
        />
        {(hasMore || loadingMore) &&
          <ShowMoreButton
            onClick={onLoadMore}
            disabled={loadingMore}
            loading={loadingMore}
          />
        }
      </main>
    </div>
  );
};

DefaultContentArchive.propTypes = CONTENT_ARCHIVE;

export default withStyles(styles)(DefaultContentArchive);
